export default __webpack_public_path__ + "d389731502c195e86605d1e3341a987e.png";